import { render, staticRenderFns } from "./rcgysq.vue?vue&type=template&id=666239e0&scoped=true&"
import script from "./rcgysq.vue?vue&type=script&lang=js&"
export * from "./rcgysq.vue?vue&type=script&lang=js&"
import style0 from "./rcgysq.vue?vue&type=style&index=0&id=666239e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666239e0",
  null
  
)

export default component.exports